import React, { useEffect, useState } from 'react'

export const MicroFrontend = ({ name, history, ...props }) => {
  const { clientHost } = props

  const [maxChunks, setMaxChunks] = useState(false)
  const [remainingChunks, setRemainingChunks] = useState(false)

  const renderMicroFrontend = () => {
    window[`render${name}`] &&
      window[`render${name}`](`${name}-micro-container`, props, history)
  }

  useEffect(() => {
    const scriptId = `micro-frontend-script-${name}`

    if (document.getElementById(scriptId)) {
      renderMicroFrontend()
      return
    }

    fetch(`${clientHost}/asset-manifest.json`, {
      cache: 'no-store',
      pragma: 'no-cache'
    })
      .then((res) => res.json())
      .then((manifest) => {
        let chunkCount = -1
        const viteManifest = manifest['index.html']
        const files = viteManifest
          ? [
              viteManifest.file,
              ...(viteManifest.css || []),
              ...(viteManifest.assets || [])
            ].reduce((prev, file) => ({ ...prev, [file]: `/${file}` }), {})
          : null
        const manifestFiles = files || manifest.files

        Object.keys(manifestFiles)
          .filter(
            (key) =>
              key.endsWith('.js') ||
              key.endsWith('.css') ||
              key.endsWith('.jsx')
          )
          .forEach((key, _, arr) => {
            if (chunkCount < 0) {
              chunkCount = arr.length
              setMaxChunks(chunkCount)
            }
            const path = `${clientHost}${manifestFiles[key]}`
            let elem = null

            if (key.endsWith('.css')) {
              if (path.endsWith('.svg')) {
                // svg's are keyed by css,
                // but firefox and safari throw errors on svg's being linked as stylesheets
                elem = document.createElement('img')
                // elem.type = 'image/svg+xml';
                elem.src = path
              } else {
                // Load css via link elements
                elem = document.createElement('link')
                elem.rel = 'stylesheet'
                elem.href = path
              }
            } else {
              // Load js via script elements
              elem = document.createElement('script')
              elem.src = path
              if (key === 'main.js') {
                elem.id = scriptId
              }
              if (key.includes('index')) {
                elem.type = 'module'
                elem.id = scriptId
              }
            }
            elem.onload = () => {
              chunkCount--
              setRemainingChunks(chunkCount)
              if (chunkCount === 0) {
                renderMicroFrontend()
              }
            }

            document.head.appendChild(elem)
          })
      })

    return () => {
      const containerId = `${name}-micro-container`
      const element = document.getElementById(containerId)
      if (element && window[`unmount${name}`]) {
        window[`unmount${name}`](containerId)
      }
    }
  }, [name])

  return (
    <div
      id={`${name}-micro-container`}
      data-max-chunks={`${maxChunks}`}
      data-remaining-chunks={`${remainingChunks}`}
    />
  )
}
